import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import AddIcon from '@material-ui/icons/Add';
import CheckIcon from '@material-ui/icons/Check';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import green from '@material-ui/core/colors/green';
import AdminExtensionAPI from '../../../API/Admin/AdminExtensionAPI';
import SnackbarAlert from '../../Utils/SnackbarAlert';
import { handleServerError, handleSpecialCharacters } from '../../../Utils/Helper';
import { ConvertDeletedToBool, ConvertDeletedFromBool } from '../../Utils/GenericFunctions';

const styles = theme => ({
  paper: {
    position: 'absolute',
    width: '50%',
    minWidth: 240,
    backgroundColor: theme.palette.background.paper
  },
  toolbarRoot: {
    padding: 0,
    backgroundColor: theme.palette.primary.dark
  },
  titleHead: {
    margin: '4px 12px',
    color: '#ffffff'
  },
  iconRight: {
    position: 'absolute',
    right: '12px'
  },
  formRoot: {
    flexGrow: 1,
    margin: '12px'
  },
  footer: {
    display: 'flex',
    position: 'relative'
  },
  buttonSuccess: {
    backgroundColor: green[400],
    '&:hover': {
      backgroundColor: green[600],
    },
  },
  fabProgress: {
    position: 'absolute',
    right: 2,
    bottom: 2,
    zIndex: 1
  },
  button: {
    margin: theme.spacing.unit,
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  },
  buttonSizeTbl: {
    width: '30px',
    height: '30px'
  },
  tblAdd: {
    color: '#ffffff',
    borderRadius: '50%',
    border: '1px solid #ffffff'
  },
  paddingAlign: {
    paddingTop: '6px'
  },
  group: {
    display: 'inline-block'
  }
});

function getModalPosition() {
  return {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  };
}


class AdminExtensionModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      reloading: false,
      success: false,
      elementDescription: '',
      active: 'no',
      openError: false,
      alertMessage: ''
    };
  }

  handleOpen = () => {
    if (this.props.element) {
      this.setState({
        openModal: true,
        elementDescription: this.props.element.Description,
        active: ConvertDeletedFromBool(this.props.element.Deleted)
      });
    }
    else {
      this.setState({ openModal: true });
    }
  };

  handleClose = () => {
    this.setState({
      openModal: false,
      reloading: false,
      success: false,
      elementDescription: '',
      active: 'no'
    });
  };

  handleChange = name => event => {
    this.setState({ [name]: handleSpecialCharacters(event.target.value) });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  handleCreate = () => {
    const adminAPI = new AdminExtensionAPI();
    this.setState({ reloading: true })
    let elementDTO = this.parseStateForSubmit(this.state);
    adminAPI.saveNewElement(elementDTO).then(() => {
      this.setState({
        reloading: false,
        success: true
      });
      setTimeout(() => {
        this.handleClose();
        this.props.reloadTable();
      }, 500)
    }).catch((error) => {
      this.setState({
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleClose();
    });
  };

  handleEdit = () => {
    const adminAPI = new AdminExtensionAPI();
    this.setState({ reloading: true })
    let elementDTO = this.parseStateForSubmit(this.state);
    adminAPI.saveEditElement(elementDTO).then(() => {
      this.setState({
        reloading: false,
        success: true
      });
      setTimeout(() => {
        this.handleClose();
        this.props.reloadTable();
      }, 500)
    }).catch((error) => {
      this.setState({
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleClose();
    });
  };

  parseStateForSubmit(estado) {
    let dto = {
      Id: this.props.element ? this.props.element.Id : 0,
      Description: estado.elementDescription,
      Deleted: ConvertDeletedToBool(estado.active)
    };
    return dto;
  };


  render() {
    const { classes } = this.props;
    const { reloading, success } = this.state;
    const buttonClassname = classNames({ [classes.buttonSuccess]: success });

    return (
      <div>

        {this.props.newEditButton ?
          <Tooltip title='Novo Elemento' placement='left-end' >
            <IconButton variant='fab' aria-label='New' onClick={this.handleOpen} className={classes.buttonSizeTbl}>
              <AddIcon className={classes.tblAdd} />
            </IconButton>
          </Tooltip>
          :
          <Tooltip title='Editar' placement='bottom' >
            <IconButton aria-label='Edit' onClick={this.handleOpen} className={classes.buttonSizeTbl} >
              <EditIcon />
            </IconButton>
          </Tooltip>
        }

        <Modal open={this.state.openModal} onClose={this.handleClose} disableAutoFocus={true}>
          <div style={getModalPosition()} className={classes.paper}>

            <Paper>
              <Toolbar className={classes.toolbarRoot}>
                <Typography variant='title' id='actionElement' className={classes.titleHead}>
                  {this.props.newEditButton ? 'NOVO ELEMENTO' : 'EDITAR ELEMENTO'}
                </Typography>
              </Toolbar>
            </Paper>

            <form className={classes.formRoot}>

              <Grid container spacing={32}>
                <Grid item xs={12} sm={8}>
                  <TextField
                    id='elementDescription'
                    label='DESCRITIVO'
                    fullWidth
                    inputProps={{ maxLength: 100 }}
                    className={classes.paddingAlign}
                    value={this.state.elementDescription}
                    onChange={this.handleChange('elementDescription')}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Grid container spacing={8} justify='flex-start' alignItems='center'>
                    <Grid item>
                      <FormLabel component='legend'>
                        ATIVO:
                      </FormLabel>
                    </Grid>
                    <Grid item>
                      <FormControl component='fieldset'>
                        <RadioGroup
                          name='elementActive'
                          className={classes.group}
                          value={this.state.active}
                          onChange={this.handleChange('active')}
                        >
                          <FormControlLabel name='yes' value='yes' label='Sim' control={<Radio color='primary' />} />
                          <FormControlLabel name='no' value='no' label='Não' control={<Radio color='primary' />} />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Toolbar className={classes.footer}>
                <div className={classes.iconRight}>
                  <Tooltip title='Cancelar' placement='bottom' >
                    <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClose}>
                      <CloseIcon />
                    </Button>
                  </Tooltip>
                  <Tooltip title='Guardar' placement='bottom' >
                    <Button disabled={reloading} variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize, buttonClassname)} onClick={this.props.newEditButton ? this.handleCreate : this.handleEdit}>
                      {success ? <CheckIcon /> : <SaveIcon />}
                    </Button>
                  </Tooltip>
                  {reloading && <CircularProgress size={48} color='primary' className={classes.fabProgress} />}
                </div>
              </Toolbar>

            </form>

          </div>
        </Modal>

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </div>
    );
  }
}

AdminExtensionModal.propTypes = {
  classes: PropTypes.object.isRequired
};

export default AdminExtensionModal = withStyles(styles)(AdminExtensionModal);


// WEBPACK FOOTER //
// ./src/components/Administration/AdminExtension/AdminExtensionModal.js